export enum StringEncoding {
    BASE64 = 'base64',
    UTF8 = 'utf8'
}



// WEBPACK FOOTER //
// ./src/models/string-encoding.ts